import React, { useEffect, useState } from 'react';
import { getBadgeFunnelStats } from 'Services/badgeAnalyticsService';

const CARDS = [
  { key: 'impressions', label: 'Badge Impressions' },
  { key: 'clicks', label: 'Clicks' },
  { key: 'waiting_room_enters', label: 'Customers Joined Waiting Room' },
  { key: 'group_meetings', label: 'Group Meetings' },
  { key: 'extra_guest_revenue', label: '$ from Extra Guests', isMoney: true },
];

const DeltaBadge = ({ delta }) => {
  if (delta == null) return null;
  const positive = delta >= 0;
  const color = positive ? '#198754' : '#dc3545';
  const arrow = positive ? '▲' : '▼';
  return (
    <span style={{ color, fontSize: '0.75rem' }}>
      {arrow} {Math.abs(delta).toFixed(1)}%
    </span>
  );
};

const SkeletonCard = () => (
  <div className="col-sm-12 col-md-6 col-lg mb-3">
    <div className="card h-100">
      <div className="card-body">
        <div
          style={{
            height: '1rem',
            background: '#e0e0e0',
            borderRadius: 4,
            marginBottom: 8,
            width: '60%',
          }}
        />
        <div
          style={{
            height: '2rem',
            background: '#e0e0e0',
            borderRadius: 4,
            width: '40%',
          }}
        />
      </div>
    </div>
  </div>
);

const BadgeFunnelCards = ({ storeId, range }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!storeId) return;
    setLoading(true);
    getBadgeFunnelStats({ storeId, range })
      .then((res) => setData(res?.data?.data || res?.data || null))
      .catch((err) => console.error('BadgeFunnelCards fetch error:', err))
      .finally(() => setLoading(false));
  }, [storeId, range]);

  if (loading) {
    return (
      <div className="row mt-3">
        {CARDS.map((c) => (
          <SkeletonCard key={c.key} />
        ))}
      </div>
    );
  }

  const allZero =
    data == null ||
    CARDS.every((c) => !data[c.key] || Number(data[c.key]) === 0);

  if (allZero) {
    return (
      <div className="alert alert-light mt-3" role="alert">
        No badge activity yet. Hosts can light the badge by going live and clicking Allow.
      </div>
    );
  }

  return (
    <div className="row mt-3">
      {CARDS.map((c) => {
        const value = data[c.key] ?? 0;
        const delta = data.deltas?.[c.key] ?? null;
        const display = c.isMoney ? `$${Number(value).toFixed(2)}` : Number(value).toLocaleString();
        return (
          <div key={c.key} className="col-sm-12 col-md-6 col-lg mb-3">
            <div className="card h-100">
              <div className="card-body">
                <p className="card-text text-muted small mb-1">{c.label}</p>
                <h4 className="card-title mb-1">{display}</h4>
                <DeltaBadge delta={delta} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BadgeFunnelCards;
